import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextMotion: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="text-motion, text-animation"><path d="M12.25 14.25H18.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.75 6.75H10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 12H8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 17.25H6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.75 19.25L15.5 5.5L21.25 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTextMotion;
